














































import Vue from 'vue';
import { Component, Prop, PropSync } from 'vue-property-decorator';
import TableHeaderPagination from './table-header-pagination.vue';
import TableFooterPagination from './table-footer-pagination.vue';
import PaginationInterface from '@core/interfaces/pagination-interface';

@Component({
  name: 'bpc-table-wrapper',
  components: {
    'bpc-table-header-pagination': TableHeaderPagination,
    'bpc-table-footer-pagination': TableFooterPagination,
  },
})
export default class TableWrapper extends Vue {
  @Prop(Boolean) readonly noHeaderPagination: boolean;
  @Prop(Boolean) readonly noFooterPagination: boolean;
  @Prop(Boolean) readonly noPagination: boolean;
  @Prop(Boolean) readonly noOrdering: boolean;
  @Prop(String) readonly headerFormClass: string;
  @PropSync('pagination', { type: Object }) syncedPagination!: PaginationInterface;
  @Prop({ type: Array, default: () => [5, 10, 15, 20, 50, 100, 200] })
  readonly pageOptions: number[];

  get showHeaderPagination(): boolean {
    return !this.noHeaderPagination && !this.noPagination;
  }

  get showOrdering(): boolean {
    return !this.noOrdering;
  }

  get showFooterPagination(): boolean {
    return !this.noPagination;
  }
  /* Lifecycle hooks */
  // created() { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
